<template>
  <div
    class="text-EXPONDO-secondary flex items-center gap-2"
    :class="{ 'basis-1/2 lg:basis-1/4 lg:flex-col lg:text-center': isHorizontal }"
  >
    <div class="w-11 h-10 shrink-0">
      <ImgView
        :src="iconPath"
      />
    </div>
    <div>
      <p
        class="font-bold text-sm leading-4"
      >
        {{ title }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'UspBlock',

  props: {
    iconPath: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
